<div class="cx-page" *ngIf="model$ | async as model; else isLoading">
  <section class="cx-page-section">
    <div class="container">
      <div class="row" *ngIf="model.freeTextSearch; else category">
        <div class="col-12 eb-product-grid__list-overview">
          <div class="eb-product-grid_list-title">
            <h1 *ngIf="model.fuzzyProducts?.length < 1">
              {{ 'productGrid.title' | cxTranslate: { search: model.freeTextSearch } }}
            </h1>
            <h1 *ngIf="model.fuzzyProducts?.length > 0">
              {{ 'productGrid.noResults.title' | cxTranslate }}
            </h1>
          </div>
          <div *ngIf="model.fuzzyProducts?.length > 0" class="eb-product-grid_list-description">
            {{
              'productGrid.noResults.description' | cxTranslate: { search: model.freeTextSearch }
            }}
          </div>
        </div>
      </div>
      <ng-template #category>
        <div class="row" *ngIf="model.categoryName">
          <div class="col-12 eb-product-grid__list-overview">
            <div class="eb-product-grid_list-title">
              <h1>{{ model.categoryName }}</h1>
            </div>
            <div class="eb-product-grid_list-description" [innerHTML]="model.categoryDescription">
              {{ model.categoryDescription }}
            </div>
          </div>
        </div>
      </ng-template>
      <div class="row">
        <div class="col-12 col-xs-4 mr-auto eb-product-grid__list-header">
          {{
            'productGrid.totalResults'
              | cxTranslate: { total: model?.pagination?.totalResults || 0 }
          }}
        </div>
      </div>
      <div class="row">
        <eb-product-scroll
          *ngIf="model?.pagination"
          data-cy="eb-product-scroll"
          [scrollConfig]="scrollConfig"
          [model]="model"
          [inputViewMode]="ViewModes.Grid"
        ></eb-product-scroll>
      </div>
    </div>
  </section>
</div>
<ng-template #isLoading>
  <eb-spinner [padding]="64" class="eb-product-grid__spinner"></eb-spinner>
</ng-template>
